import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { DEVELOPMENT_LEVELS } from '../../shared/developmentLevels';

export default function DevelopmentLevelSelector({ studentName, value, disabled, onChange, expanded = false, trailingAction, describedBy, renderActions }) {
  const clearAction = <Button size="small" disabled={disabled || !value} onClick={() => onChange('')}
    aria-label={`${studentName} düzey seçimini temizle`}
    sx={{ minHeight: 44, textTransform: 'none',
      '&:focus-visible': { outline: '3px solid #302479', outlineOffset: 2 } }}>Seçimi temizle</Button>;
  return (
    <Box sx={{ width: '100%', minWidth: 0 }}>
      <ToggleButtonGroup exclusive value={value || null} disabled={disabled}
        aria-label={`${studentName} gelişim düzeyi`}
        aria-describedby={describedBy}
        onChange={(_, next) => onChange(next || '')}
        sx={{ width: '100%', display: 'grid', gridTemplateColumns: 'repeat(2,minmax(0,1fr))', gap: 0.75,
          ...(expanded ? { '@container student-result-entry (min-width:600px)': { gridTemplateColumns: 'repeat(4,minmax(0,1fr))' } } : {}),
          '& .MuiToggleButtonGroup-grouped': { m: 0, border: '1px solid', borderColor: 'divider',
            borderRadius: '8px !important', minHeight: 44, minWidth: 44, textTransform: 'none',
            color: 'text.primary', fontSize: 13, lineHeight: 1.4,
            '&.Mui-selected': { bgcolor: '#ede7f6', color: '#45277b', borderColor: '#6744a3', fontWeight: 700 },
            '&.Mui-focusVisible': { outline: '3px solid #302479', outlineOffset: 2 } } }}>
        {DEVELOPMENT_LEVELS.map(level => (
          <ToggleButton key={level.code} value={level.code} aria-label={`${studentName}: ${level.label}`}>
            {level.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      {renderActions ? renderActions(clearAction) : <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 1, mt: expanded ? 1 : 0 }}>
        {clearAction}
        {trailingAction}
      </Box>}
    </Box>
  );
}
